import { apiRequestDev } from './apiRequest';

export const getAllRidings = async (config) => apiRequestDev(config, '/ridings/all');

export const getRiding = async (config, id) => apiRequestDev(config, `/ridings/user?id=${id}`);

export const assignRiding = async (config, mppId, ridingId) => {
  return apiRequestDev(config, '/ridings/assign', 'post', {
    mpp_id: mppId,
    riding_id: ridingId,
  });
};

export const updateRiding = async (config, mppId, ridingId) => {
  return apiRequestDev(config, '/ridings/update', 'patch', {
    mpp_id: mppId,
    riding_id: ridingId,
  });
};

export const deleteRiding = async (config, id) => apiRequestDev(config, `/ridings/${id}/delete`, 'delete');
